"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.form.title.edit': 'Edit User Group',
    'userGroup.form.title.add': 'Add User Group',
    'userGroup.form.back': 'Back',
    'userGroup.form.name.label': 'Group Name',
    'userGroup.form.name.placeholder': 'Enter group name',
    'userGroup.form.description.label': 'Description',
    'userGroup.form.description.placeholder': 'Enter group description',
    'userGroup.form.active.label': 'Active',
    'userGroup.form.acl.label': 'Access Control',
    'userGroup.form.acl.description': 'Configure access permissions for this user group',
    'userGroup.form.submit.update': 'Update User Group',
    'userGroup.form.submit.create': 'Create User Group',
    'userGroup.form.saved': 'User group saved successfully',
    'userGroup.form.error.save': 'Failed to save user group',
};
